import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-generic',
  templateUrl: './dialog-generic.component.html',
  styleUrls: ['./dialog-generic.component.css']
})
export class DialogGenericComponent {

  constructor(
    public dialogRef: MatDialogRef<DialogGenericComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  form!: FormGroup
  mostrarVolver: boolean = true;
  ngOnInit(): void {
  }
  close(navigate: boolean): void {
      this.dialogRef.close(navigate);
  }

}
